import stockadjustment from '@/api/stock-adjustment'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  edit_data: {},
  products: [],
  uoms: [],
  branch_id: null
}

export const getters = {
  getUOM: state => objectRow => {
    if (objectRow.product_id !== '') {
      let products = state.products
        .filter(p => p.product_id == objectRow.product_id)
        .reduce((init, item) => (init = item), {})

      return state.uoms
        .filter(uomc => uomc.uom_cat_id == products.uom_cat_id)
        .reduce((init, item) => item.unit_of_measures, [])
        .filter(u => u.is_default == true)
    }
    return
  }
}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA (state, data) {
    state.edit_data = data
  },
  SET_PRODUCT (state, data) {
    state.products = data
  },
  SET_UOM (state, data) {
    state.uoms = data
  },
  SET_BRANCH_ID (state, data) {
    state.branch_id = data
  }
}

export const actions = {
  fetch (context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        all_branch: Array.isArray(context.state.branch_id)
          ? context.state.branch_id.length
            ? undefined
            : true
          : true
      },
      attrubutes
    )
    return stockadjustment.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store (context, data) {
    return stockadjustment.store(data)
  },

  update (context, data) {
    return stockadjustment.update(data)
  },
  destroy (context, id) {
    return stockadjustment.destroy(id)
  },

  async find (context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await stockadjustment.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  async getSystemQty (context, product_id) {
    return await stockadjustment.getSystemQty(product_id)
  },
  async dataBeforeCreate (context) {
    if (!context.state.products.length > 0) {
      let response = await stockadjustment.getProduct()
      context.commit('SET_PRODUCT', response.data)
    }
    if (!context.state.uoms.length > 0) {
      let response = await stockadjustment.getUOM()
      context.commit('SET_UOM', response.data)
    }
  }
}
